import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import {pending} from '../stores/State'
import Domain from '@material-ui/icons/Domain';

@inject('store')
@observer
class CustomerInventoryLocations extends Component {
  
  handleRowClick(location){
    this.props.history.push(`/inventory_locations/${location.id}`);    
  }
  render() {
    const { classes } = this.props;
    const  store  = this.props.store.inventoryLocationStore;
    return (
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><Domain/>Inventory locations</Typography>
        { store.inventoryLocationsState === pending && <CircularProgress /> }
        { store.inventoryLocations && 
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Fill rate</TableCell>
                <TableCell numeric>Inventory count</TableCell>
                <TableCell numeric>Inventory weight</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {store.inventoryLocations.map(location => {
                return (
                  <TableRow key={location.id} hover onClick={()=>this.handleRowClick(location)}>
                    <TableCell>{location.name}</TableCell>
                    <TableCell>{(location.fill_rate*100).toFixed(0)}%</TableCell>
                    <TableCell numeric>{location.inventory_count}/{location.capacity}</TableCell>
                    <TableCell numeric>{location.inventory_weight} kg</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table> }
        </Paper>
    );
  }
}


const styles = theme => ({
  paper: {
    padding: 20
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

export default withRouter(withStyles(styles)(CustomerInventoryLocations));



// WEBPACK FOOTER //
// ./src/components/CustomerInventoryLocations.js